// extracted by mini-css-extract-plugin
module.exports = {"icon":"SideButton_icon__RZGKJ"};